/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    fill: inherit;
  }
`
export default class WriteMessageIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" css={Color}>
        <g id="그룹_15568" data-name="그룹 15568" transform="translate(9283 11995)">
          <rect id="사각형_9398" data-name="사각형 9398" width="30" height="30" transform="translate(-9283 -11995)" fill="#5c5c5c" opacity="0"/>
          <g id="그룹_15567" data-name="그룹 15567">
            <path id="합치기_450" className="fill" data-name="합치기 450" d="M1.5,12,4,14.5l-2.75.25Zm0,0L11,2.5,13.5,5,4,14.5Zm10-10,.75-.75a1.768,1.768,0,0,1,2.5,2.5L14,4.5Z" transform="translate(-9275.949 -11988.001)" fill="#5c5c5c"/>
          </g>
        </g>
      </svg>
    )
  }
}
